"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRegionCode = void 0;
const country_region_data_1 = __importDefault(require("country-region-data"));
const string_1 = require("../../helpers/string");
const registry_1 = require("./registry");
const buildResolutionLookup = () => {
    const lookup = new Map();
    for (const country of country_region_data_1.default) {
        const countryCode = country.countryShortCode;
        const map = new Map();
        for (const region of country.regions) {
            if (!region.shortCode) {
                continue;
            }
            map.set(region.shortCode.toLowerCase(), region.shortCode);
            map.set((0, string_1.normalizeAccents)(region.name), region.shortCode);
        }
        lookup.set(countryCode, map);
    }
    return lookup;
};
const RESOLUTION_LOOKUP = buildResolutionLookup();
const resolveRegionCode = (country, rawRegion) => {
    const countryCode = (0, registry_1.toCountryCode)(country);
    if (!countryCode || !rawRegion) {
        return null;
    }
    const map = RESOLUTION_LOOKUP.get(countryCode);
    if (!map) {
        return null;
    }
    const trimmed = rawRegion.trim();
    if (!trimmed) {
        return null;
    }
    return map.get(trimmed.toLowerCase()) ?? map.get((0, string_1.normalizeAccents)(trimmed)) ?? null;
};
exports.resolveRegionCode = resolveRegionCode;
